import ApiClient from '../../../../../resources/js/apiClient'

class ApiService {
  constructor (config) {
    this.http = new ApiClient(config)
  }

  /**
   * Возвращает файловый поток для ZIP-архива
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getArchiveForDownload (id) {
    const params = { id }
    return this.http.get('/api/serm/download', { params })
  }

  /**
   * Возвращает файловый поток для конкретного файла
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getFileForDownload (id) {
    const params = { id }
    return this.http.get('/api/serm/download/file', { params })
  }

  /**
   * Возвращает содержимое конкретного файла для просмотра
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getFileForPreview (id) {
    const params = { id }
    return this.http.get('/api/serm/preview/file', { params })
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<T>>}
   */
  getAnalytics (domain) {
    return this.http.get('/api/serm/analytics', {
      params: {
        domain
      }
    })
  }

  /**
   * @returns {Promise<AxiosResponse<T>>}
   */
  getDomains () {
    return this.http.get('/api/serm/domains')
  }

  /**
   * @param {String} domain
   * @param {String} from
   * @param {String} to
   * @param {String} reportType
   * @returns {Promise<AxiosResponse<T>>}
   */
  getReports (domain, from, to, reportType) {
    return this.http.get('/api/serm/reports', {
      params: {
        domain,
        from,
        to,
        reportType
      }
    })
  }

  /**
   * @param {String} domain
   * @returns {Promise<AxiosResponse<T>>}
   */
  getRegions (domain) {
    return this.http.get('/api/serm/regions', {
      params: {
        domain
      }
    })
  }

  /**
   * @param {String} domain
   * @param {String} from
   * @param {String} to
   * @param {int} regionId
   * @param {String} sengine
   */
  getReviewsStatisticsForTable (domain, from, to, regionId, sengine) {
    return this.http.get('/api/serm/reviews/query-stats', {
      params: {
        domain,
        from,
        to,
        regionId,
        sengine
      }
    })
  }

  /**
   * @param {String} domain
   * @param {String} from
   * @param {String} to
   * @param {int} regionId
   * @param {String} sengine
   */
  getReviewsStatisticsForChart (domain, from, to, regionId, sengine) {
    return this.http.get('/api/serm/reviews/chart-stats', {
      params: {
        domain,
        from,
        to,
        regionId,
        sengine
      }
    })
  }
}

export default new ApiService({
  responseType: 'json'
})
